import React from 'react'
import { makeStyles, CircularProgress } from '@material-ui/core'
import { FONT_WEIGHTS } from '../../../utils'

const ActivityAlert = ({ text = '' }) => {
	const classes = useStyles()()

	return (
		<div className={classes.root}>
			<div className={classes.iconContainer}>
				<CircularProgress size={18} />
			</div>
			<div className={classes.textContainer}>{text}</div>
		</div>
	)
}

const useStyles = () =>
	makeStyles(() => ({
		root: {
			backgroundColor: 'white',
			padding: '.5rem .8rem',
			borderRadius: '.375rem',
			display: 'flex',
			gap: '.4rem'
		},
		iconContainer: {
			display: 'flex',
			alignItems: 'center'
		},
		textContainer: {
			flex: 1,
			fontFamily: 'Nunito',
			fontSize: '0.875rem',
			display: 'flex',
			alignItems: 'center',
			fontWeight: FONT_WEIGHTS.SemiBold
		}
	}))

export default ActivityAlert
